import { setTrialPlacementOptions } from './index';

const convertPolygonCoordinates = (geometry) => {
  return {
    type: geometry.type,
    coordinates: geometry.polygonCoordinates || geometry.multiPolygonCoordinates
  };
};

export const processTrialPlacementOptions = ({ dispatch, trialPlacements }) => {
  const {
    recommended: trialPlacementOptions = []
  } = trialPlacements;

  let normalizedTrialPlacementOptions = {};

  trialPlacementOptions.map((placement) => {
    const challengers = placement.challengers.reduce((acc, curr) => acc.concat(curr), []);
    const [{boundary: challengerBoundary, ...challenger}] = challengers;
    const {boundary: championBoundary, ...champion} = placement.champion;
    normalizedTrialPlacementOptions = {
      [placement.id]: {
        id: placement.id,
        // Order matters here. Champion should be the latest
        // layer we render so borders styles matches what design wants.
        zones: {
          challenger: {
            ...challenger,
            geoJson: {
              ...convertPolygonCoordinates(challengerBoundary),
              properties: {}
            }
          },
          champion: {
            ...champion,
            geoJson: {
              ...convertPolygonCoordinates(championBoundary),
              properties: {}
            }
          }
        }
      },
      ...normalizedTrialPlacementOptions
    };
  });

  dispatch(setTrialPlacementOptions(normalizedTrialPlacementOptions));

  return Promise.resolve(normalizedTrialPlacementOptions);
};
